<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
    <div class="container">
     <div class="">
      <div class="row mt-2 mt-md-0">
        <aside class="col-sm-6 col-md-4 col-lg-3">
        <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
        </aside>

      
        <div class="col-sm-6 col-md-9 col-lg-9 mt-3 mt-md-0 rside-text">
            <app-userheading-section></app-userheading-section>

      <div  *ngIf="isLoading"> 
              
              <div class="my-accountload text-center">
              	<span class="lodercont">
              	  <app-refreshloader> </app-refreshloader>
              	</span>
              </div>
      </div>
           

            
            <div class="row">

                <div class="col-md-6 mb-4">
                   <div class="profile-content h-100">
                      <h3>{{ 'myaccount.login_information' | translate }} <a class="edit-info" [routerLink]="['/my-account/editprofile']"><i class="fas fa-pencil-alt"></i> {{ 'myaccount.edit' | translate }}</a></h3>
                      <ul>
                          <li><span>{{ 'myaccount.login_id' | translate }} : </span> {{userdata['uEmail']}}</li>
                          <li><span>{{ 'myaccount.password' | translate }} : </span> ********</li>
                          <li><span>{{ 'myaccount.phone_no' | translate }}: </span> {{userdata['uPhone']}}</li>
                      </ul>
                  </div> 
              </div>

      <div class="col-md-6 mb-4">
        <div class="profile-content h-100">
           <h3> {{ 'myaccount.recent_order' | translate }}</h3>  
       <div *ngIf="recentOrder; else noorder">
         <ul>
           <li> <span> {{ 'myaccount.order_id' | translate }} : </span> {{recentOrder['orderid']}}</li>
           <li> <span> {{ 'myaccount.order_date' | translate }} : </span> {{recentOrder['created_at'] | date : 'yyyy-MM-dd'}} </li>
           <li><span>{{ 'myaccount.order_status' | translate }} : </span> 

            <span class="text-danger" *ngIf="showLang == 'en' " >{{this.ordStatus}}</span> 
            <span class="text-danger" *ngIf="showLang == 'ar' " >{{this.ordStatus_ar}}</span> 
          </li>
       </ul>
       <hr>
       <a [routerLink]="['order-details', recentOrder['orderid'] ]" class="float-right btn btn-primary comm-btn "> {{ 'myaccount.view_detail' | translate }} </a>
       <a [routerLink]="['track-order', recentOrder['orderid'] ]" class="float-right btn btn-primary comm-btn mr-1">{{ 'myaccount.track_order' | translate }} </a>
      
       <h6 class="price">AED {{recentOrder['finalTotal']}}</h6>
     </div>

     <ng-template #noorder>
      <div class="noaddress text-center">
        <p class="mb-2">{{ 'myaccount.no_order' | translate }}  </p>
        <a class="order-now" [routerLink]="['/order-online']">{{ 'myaccount.order_now' | translate }}</a>
      </div>
    </ng-template>


    </div>
     </div>

      <div class="col-md-6 mb-4">
       <div class="profile-content h-100">
            <h3>{{ 'myaccount.delivery_address' | translate }}
                <a class="edit-info" 
                [routerLink]="['/my-account/editaddress', adrsData['id']]" 
                *ngIf="isEmptyAdr; else addaddresslink">
                <i class="fas fa-pencil-alt"></i> {{ 'myaccount.edit' | translate }}
                </a>

               <ng-template #addaddresslink>
                <a class="edit-info" 
                [routerLink]="['/my-account/add-address']" 
                *ngIf="!isEmptyAdr">
                <i class="fas fa-pencil-alt"></i> {{ 'myaccount.add' | translate }}
                </a>
               </ng-template>

            </h3>
          <ul *ngIf="isEmptyAdr; else noaddress">
            <li> <span> {{ 'myaccount.name' | translate }}: </span> {{adrsData['userName']}} </li>
            <li><span>{{ 'myaccount.phone' | translate }} :</span> {{adrsData['phoneNumber']}}</li>                                        
            <li> <span> {{ 'myaccount.address' | translate }}: </span> {{adrsData['address_one']}} </li>
            <li> <span> {{ 'myaccount.landmark' | translate }}: </span> {{adrsData['address_two']}} </li>
            <li><span>{{ 'myaccount.city' | translate }} :</span> {{adrsData['city']}}</li>
            <li><span>{{ 'myaccount.state' | translate }} :</span> {{adrsData['state']}}</li>
            <li><span>{{ 'myaccount.country' | translate }} :</span> {{adrsData['country']}}</li>
          </ul>
          <ng-template #noaddress>
          <div class="noaddress text-center mt-4">
            <p class="mb-2"> {{ 'myaccount.no_address' | translate }} </p>
            <a class="order-now" [routerLink]="['/my-account/add-address']">{{ 'myaccount.add_address' | translate }}</a>
          </div>
        </ng-template>
      </div>
  </div>




</div>



  
  
                      </div>
                  </div>
              </div>
          </div>
      </section>
